import { render, staticRenderFns } from "./Tabela.vue?vue&type=template&id=e2bcc072&scoped=true"
import script from "./Tabela.vue?vue&type=script&lang=js"
export * from "./Tabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bcc072",
  null
  
)

export default component.exports